$(function(){
    $('.user-change-photo').click(function() {
        $('.toggle-upload').slideToggle();
    });

    $('#block_main').on('change', '.certificate', function() {
        var item = $(this);
        var parentCont = item.parents('.skill-lang-items');
        var infoCont = parentCont.find('.has-certificate');
        var target = event.target.nodeName;

        var val = parseInt(item.val());

        if(val == 2) {
            infoCont.show();
        } else if(val == 1 && event.target.nodeName == 'SELECT') {
            infoCont.hide();
            infoCont.find('textarea').val('');
        }
    });

    $('#summary-controls-btn').on('change', function() {
        var value = 2;
        var item = $(this);        
        var method = item.parents('.summary-controls').data('method');
        var button_labels = item.parents('.summary-controls').find('.btn');
        var loading = $('.spinner-loader:not(:required)');
        var textCont = $('.summery-controls-text');
        textCont.empty();
        textCont.show();
        if(item.is(':checked')) {
            value = 1;
        }

        if (value && method) {
            $.ajax({
                url: Main.site_url + 'resume/updateBlockVisibility/' + value + '/' + method,
                type: 'post',
                cache: false,
                timeout: 5000,
                dataType: 'json',
                beforeSend: function (jqXHR, settings) {
                    button_labels.attr('disabled', true);                    
                    loading.show();
                },
                success: function (res) {
                    button_labels.attr('disabled', false);                    
                    loading.hide();
                    textCont.text(res.data);
                    textCont.delay(2000).fadeOut('slow');                     
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    button_labels.attr('disabled', false);
                    loading.hide();
                    textCont.text(textStatus);
                }
            });
        }
    });

    countryChange();
});

function countryChange()
{
    $('.country').on('change', function() {
        var item = $(this);
        var val = item.val();
        var itemCont = item.parents('.form-group');
        var cityCont = itemCont.find('.city-cont');
        var citiesSelect = itemCont.find('.city');

        if(parseInt(val)) {
            $.ajax({
                url: Main.site_url + 'resume/getCitiesData/' + val,
                type: 'post',
                cache: false,
                timeout: 5000,
                dataType: 'json',
                beforeSend: function (jqXHR, settings) {
                    
                },
                success: function (res) {                    
                    if(res.status == 'ok') {                                                
                        var data = JSON.parse(res.data).map(function(obj) {
                            return {
                                id: obj.id,
                                text: obj.name
                            };
                        });
                
                        citiesSelect.html('');
                        citiesSelect.select2({
                            tags: true,
                            data: data,
                        });                        
                    } else {
                        var data = [{id:0, text: Main.txts.citySelectValue}];
                        citiesSelect.html('');
                        citiesSelect.select2({
                            tags: true,  
                            data: data
                        });
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    
                }
            });
        }
    });
}
